import { ListItem } from 'components/shared/NumberedList';

export const COPY = {
  header: 'Apply for finance for your purchase from us',
  body: "We at {{trading_name}} have partnered with Ideal4Finance to be able to offer finance. To start applying for finance, just complete this quick form to let us know your quote details. Here's how it works:",
};

export const LIST: ListItem[] = [
  {
    header: 'Provide Some Contact Information',
    content:
      'This ensures that both Ideal4Finance and their lending partners can contact you if you are eligible for finance',
  },
  {
    header: 'Upload Your Quote',
    content:
      "Provide Ideal4Finance with the quote you've received from us so that they know how much you need to borrow and the type of work being carried out",
  },
  {
    header: 'Apply For Finance',
    content:
      "Once you've sent the above information, we will confirm the quote details with Ideal4Finance. They will then send you a link to apply for finance",
  },
];
